<template>
  <div class="faq-page">
    <Top />

    <section class="hero" aria-label="FAQ header">
      <div class="container hero-inner">
        <img class="hero-banner" :src="banner" alt="" />
      </div>
    </section>

    <section class="faq" aria-label="FAQ list">
      <div class="container faq-inner">
        <div v-if="listLoading" class="state-msg">Loading…</div>
        <div v-else-if="listError" class="state-msg state-err">{{ listError }}</div>
        <div v-else-if="!displayItems.length" class="state-msg">No FAQs yet.</div>
        <div v-else class="accordion" role="list">
          <div v-for="(item, idx) in displayItems" :key="'faq-' + item.id" class="acc-item" role="listitem">
            <button
              class="acc-q"
              type="button"
              :aria-expanded="openIdx === idx ? 'true' : 'false'"
              :aria-controls="'faq-a-' + item.id"
              @click="toggle(idx)"
            >
              <span class="acc-q-text">{{ item.q }}</span>
              <span class="acc-icon" aria-hidden="true" />
            </button>

            <div
              :id="'faq-a-' + item.id"
              class="acc-a"
              :class="{ open: openIdx === idx }"
              role="region"
              :aria-label="item.q"
            >
              <div class="acc-a-inner">
                {{ item.a }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-band">
      <div class="container cta-inner">
        <div class="cta-left">
          <h2 class="cta-title">AESTHETICS PRACTITIONER?</h2>
          <p class="cta-sub">
            Grow your business with DOSE and access new patients, forms, diary, reminders<br />
            and no show/late cancellation protection.
          </p>
        </div>
        <div class="cta-right">
          <button class="cta-btn" type="button" @click="goAbout">LEARN MORE</button>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script>
import Footer from '../components/footer.vue'
import Top from '../components/top.vue'
import { fetchPublicFaqList } from '../api/faq'

export default {
  name: 'FaqPage',
  components: {
    Footer,
    Top,
  },
  data() {
    return {
      banner: require('../assets/images/faqBanner.jpg'),
      openIdx: 0,
      listLoading: true,
      listError: '',
      listRows: [],
    }
  },
  computed: {
    displayItems() {
      return (this.listRows || []).map((row) => ({
        id: row.id,
        q: row.question != null ? String(row.question).trim() : '',
        a: this.stripHtmlAnswer(row.answer),
      }))
    },
  },
  watch: {
    displayItems: {
      handler(list) {
        if (!list.length) {
          this.openIdx = -1
          return
        }
        if (this.openIdx < 0 || this.openIdx >= list.length) {
          this.openIdx = 0
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadList()
  },
  methods: {
    /** 答案按纯文本展示：去掉标签与脚本块，合并空白 */
    stripHtmlAnswer(raw) {
      if (raw == null) return ''
      let s = String(raw)
      s = s.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, ' ')
      s = s.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, ' ')
      s = s.replace(/<[^>]+>/g, ' ')
      s = s.replace(/&nbsp;/gi, ' ')
      s = s.replace(/\u00a0/g, ' ')
      s = s.replace(/\s+/g, ' ').trim()
      return s
    },
    loadList() {
      this.listLoading = true
      this.listError = ''
      fetchPublicFaqList()
        .then((rows) => {
          this.listRows = rows || []
        })
        .catch((e) => {
          this.listError = (e && e.message) || 'Failed to load FAQs'
          this.listRows = []
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    toggle(idx) {
      this.openIdx = this.openIdx === idx ? -1 : idx
    },
    goAbout() {
      this.$router.push({ name: 'about' }).catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') throw err
      })
    },
  },
}
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  background: #ffffff;
  color: #0c0b06;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.hero {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.hero-inner {
  padding: 0;
}

.hero-banner {
  width: 100%;
  height: auto;
  display: block;
}

.hero-title {
  margin: 0;
  font-size: 34px;
  font-weight: 500;
  color: #0c0b06;
  letter-spacing: 0.01em;
}

.hero-sub {
  margin: 10px 0 0;
  font-size: 12px;
  line-height: 1.7;
  color: #0c0b06;
  max-width: 520px;
}

.hero-right {
  display: flex;
  justify-content: flex-end;
}

.hero-deco {
  width: min(360px, 34vw);
  height: 120px;
  border-radius: 12px;
  background:
    radial-gradient(120px 120px at 70% 40%, rgba(176, 138, 74, 0.16), rgba(176, 138, 74, 0)),
    radial-gradient(160px 160px at 30% 70%, rgba(0, 0, 0, 0.06), rgba(0, 0, 0, 0)),
    linear-gradient(90deg, rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.15));
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.faq-inner {
  padding: 26px 0 54px;
}

.state-msg {
  padding: 40px 0;
  text-align: center;
  color: #0c0b06;
  font-size: 13px;
}

.state-err {
  color: #a94442;
}

.accordion {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.acc-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.acc-q {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 14px 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
}

.acc-q-text {
  font-size: 14px;
  line-height: 1.6;
  color: #0c0b06;
  font-weight: 500;
}

.acc-q[aria-expanded='true'] .acc-q-text {
  color: #bc955a;
}

.acc-icon {
  width: 18px;
  height: 18px;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  position: relative;
  flex: 0 0 auto;
}

.acc-icon::before,
.acc-icon::after {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 9px;
  height: 1px;
  color: #0c0b06;
  transform: translate(-50%, -50%);
}

.acc-icon::after {
  transform: translate(-50%, -50%) rotate(90deg);
}

.acc-a {
  max-height: 0;
  overflow: hidden;
  transition: max-height 200ms ease;
}

.acc-a.open {
  max-height: 4000px;
}

.acc-a-inner {
  padding: 0 6px 16px;
  font-size: 14px;
  line-height: 1.8;
  color: #0c0b06;
}

.acc-q[aria-expanded='true'] .acc-icon::after {
  transform: translate(-50%, -50%) rotate(0deg);
  opacity: 0;
}

.cta-band {
  padding: 44px 0;
  background: #f4f3ef;
}

.cta-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 22px;
}

.cta-title {
  margin: 0;
  font-size: 18px;
  letter-spacing: 0.08em;
  font-weight: 600;
}

.cta-sub {
  margin: 10px 0 0;
  color: #0c0b06;
  font-size: 12px;
  line-height: 1.7;
}

.cta-btn {
  height: 36px;
  min-width: 150px;
  padding: 0 26px;
  border: none;
  border-radius: 0;
  background: #b08a4a;
  color: #fff;
  font-size: 11px;
  letter-spacing: 0.14em;
  cursor: pointer;
}

.cta-btn:hover {
  filter: brightness(0.96);
}

@media (max-width: 1000px) {
  .hero-right {
    display: none;
  }
}

@media (min-width: 1001px) {
  .hero {
    background: url('../assets/images/faqBanner.jpg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  .hero-inner {
    height: 330px;
    padding: 0 12px;
  }

  .hero-banner {
    display: none;
  }
}

@media (max-width: 720px) {
  .container {
    padding: 0;
  }

  .faq-inner {
    padding: 26px 12px 54px;
  }

  .acc-q {
    padding: 14px 2px;
  }

  .acc-q-text {
    font-size: 12px;
  }

  .acc-a-inner {
    padding: 0 2px 16px;
    font-size: 11px;
  }

  .cta-inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .cta-btn {
    width: 100%;
    max-width: 220px;
  }
  .cta-band{
    width:100%;
    box-sizing: border-box;
    padding:44px 12px;
  }
}
</style>
